import { TYPE_FILE } from "components/Form/Input";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FileUploadZone = ({
    onFileSelect,
    fileUploadDisabled,
    acceptedTypes,
    multiple
}) => {

    return (
        <div
            className={ classNames('paperclip', { disabled: fileUploadDisabled }) }
        >
            <label className="icon fas fa-paperclip">
                <input
                    type={ TYPE_FILE }
                    multiple={ multiple }
                    accept={ acceptedTypes }
                    disabled={ fileUploadDisabled }
                    onChange={ onFileSelect }
                    className="file-uploader"
                    id="file-input"
                />
            </label>
        </div>
    );
};

FileUploadZone.propTypes = {
    onFileSelect: PropTypes.func.isRequired,
    fileUploadDisabled: PropTypes.bool,
    acceptedTypes: PropTypes.string,
    multiple: PropTypes.bool,
};

FileUploadZone.defaultProps = {
    fileUploadDisabled: false,
    acceptedTypes: "image/*,video/*",
    multiple: true,
};

export default FileUploadZone;
